import PageHeading from '~/components/PageHeading';
import useBusinessNavigate from '~/lib/useBusinessNavigate';
import { useCouponsQuery } from '~/lib/Queries';
import Loading from '~/components/Loading';
import Table from '~/components/Table';
import FeatureIntro from '~/components/FeatureIntro';
import React from 'react';
import GateRequiresPaymentProcessor from '~/components/GateRequiresPaymentProcessor';
import { couponHumanDiscount } from '~/lib/CouponHelpers';
import { formatDate } from '~/lib/DateTime';

const CouponRow = ({ coupon, isFirst }) => {
    const navigate = useBusinessNavigate();

    return (
        <div
            key={coupon.id}
            className={`py-3 flex-1 flex cursor-pointer ${!isFirst ? 'border-t' : ''}`}
            onClick={() => navigate(`/coupons/${coupon.id}`)}
        >
            <div className="flex-1">{coupon.name}</div>
            <div className="flex-1">{couponHumanDiscount(coupon)}</div>
            <div className="flex-1">
                {coupon.expires_at
                    ? formatDate(coupon.expires_at)
                    : 'No expiration'}
            </div>
        </div>
    );
};

const CouponsIndexPage = ({}) => {
    const navigate = useBusinessNavigate();
    const { data, isLoading } = useCouponsQuery();

    const coupons = data?.coupons || [];

    return (
        <div>
            <PageHeading
                heading="Coupons"
                rightContent={
                    <button
                        type="button"
                        className="btn-pill"
                        onClick={() => navigate('/coupons/0')}
                    >
                        Add Coupon
                    </button>
                }
            />
            <FeatureIntro>
                Provide promotions and discounts with coupon codes that can be
                entered on the checkout page
            </FeatureIntro>

            <GateRequiresPaymentProcessor className="mt-6 mb-4 max-w-2xl" />

            {coupons?.length > 0 && (
                <Table
                    headers={['Name', 'Discount', 'Expiration']}
                    rowClassName="cursor-pointer"
                    rows={coupons.map(coupon => [
                        coupon.name,
                        couponHumanDiscount(coupon),
                        coupon.expires_at ? formatDate(coupon.expires_at) : 'No expiration',
                    ])}
                    onClick={row => {
                        const coupon = coupons.find(c => c.name === row[0]);
                        if (coupon) {
                            navigate(`/coupons/${coupon.id}`);
                        }
                    }}
                />
            )}


            {isLoading && <Loading />}

            {coupons?.length === 0 && !isLoading && (
                <div className="panel px-6 py-4">
                    There are no coupons, click the "Add Coupon" button above to create your first discount.
                </div>
            )}
        </div>
    );
};

export default CouponsIndexPage;
